import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './employeeproductivityformanager.css';
import ProjectManagerAside from './ProjectManagerAside';

const EmployeeProductivityManager = () => {
  const [productivityData, setProductivityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Fetch productivity data when the component mounts
  useEffect(() => {
    const fetchProductivityData = async () => {
      try {
        const response = await axios.get('https://cleezoclass.com:8443/api/employee-productivity-manager');

        if (response.data.success) {
          setProductivityData(response.data.data);

          response.data.data.forEach((task) => {
            handleSubmit(task); // Submit the data if not already stored
          });
        } else {
          setMessage({ text: 'Failed to fetch data', type: 'error' });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setMessage({ text: 'Error fetching data', type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchProductivityData();
  }, []);

  // Function to calculate productivity percentage
  const calculateProductivity = (task_hours, hours_worked) => {
    const taskHoursInSeconds = timeToSeconds(task_hours);
    const hoursWorkedInSeconds = timeToSeconds(hours_worked);
    const productivity = taskHoursInSeconds > 0 ? (hoursWorkedInSeconds / taskHoursInSeconds) * 100 : 0;
    return productivity.toFixed(2);
  };

  // Helper function to convert time (HH:MM:SS) to seconds with error handling
  const timeToSeconds = (timeStr) => {
    if (!timeStr || typeof timeStr !== 'string') {
      console.warn("Invalid time string received:", timeStr);
      return 0; // Return 0 if the input is invalid
    }

    const [hours, minutes, seconds] = (timeStr || '00:00:00').split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + (seconds || 0); // Ensure seconds is valid
  };

  // Handle the submission of the task data
  const handleSubmit = async (task) => {
    console.log("Processing Task:", task); // Debugging log
    const productivity = calculateProductivity(task.task_hours, task.hours_worked);

    const taskWithProductivity = { 
      ...task, 
      employee_productivity: productivity  
    };

    try {
      const checkResponse = await axios.post('https://cleezoclass.com:8443/api/check-productivity', { id: task.id });

      if (checkResponse.data.exists) {
        console.log(`Task with ID ${task.id} already exists. Skipping submission.`);
        return;
      }

      const response = await axios.post('https://cleezoclass.com:8443/api/store-productivity', taskWithProductivity);
      
      if (response.data.success) {
        console.log('Data stored successfully');
        setMessage({ text: 'Data stored successfully', type: 'success' });
      } else {
        console.error('Failed to store data:', response.data.message);
        setMessage({ text: 'Failed to store data: ' + response.data.message, type: 'error' });
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      setMessage({ text: 'Error storing data: ' + error.message, type: 'error' });
    }
  };

  if (loading) {
    return <div className="employee-productivity-manager-loading-msg">
      <ProjectManagerAside />
      Loading...</div>;
  }

  return (
    <div className="employee-productivity-manager-container mainBlock">
      <ProjectManagerAside />
      <h1 className="employee-productivity-manager-heading">Employee Productivity</h1>

      {/* Display Success or Error Message */}
      {message.text && (
        <div
          className={`employee-productivity-manager-message ${message.type === 'success' ? 'success' : 'error'}`}
        >
          {message.text}
        </div>
      )}

      {/* Table section with scroll */}
      <div className="employee-productivity-manager-table-wrapper">
        <table className="employee-productivity-manager-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Project Name</th>
              <th>Task Name</th>
              <th>Task Hours</th>
              <th>Hours Worked</th>
              <th>Productivity (%)</th>
            </tr>
          </thead>
          <tbody>
            {productivityData.map((task) => {
              console.log("Rendering Task:", task); // Debugging log

              return (
                <tr key={task.id}>
                  <td>{task.id}</td>
                  <td>{task.empId}</td>
                  <td>{task.empName}</td>
                  <td>{task.project_name}</td>
                  <td>{task.task_name}</td>
                  <td>{task.task_hours || "00:00:00"}</td>
                  <td>{task.hours_worked || "00:00:00"}</td>
                  <td>{calculateProductivity(task.task_hours, task.hours_worked)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeProductivityManager;
